import React from 'react';
import {connect} from 'react-redux';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useBoolean, useToggle} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import {useImageResults} from './imageResultsHelper';
import {customImagePermissionsSelector} from '../../../store/selectors/user.selectors';
import ImageWizard from '../../Wizards/ImageWizard';
import ImageFilterPane from '../../Filters/ImageFilterPane';
import {helpContextPageUrl} from '../../../conf/Routes';
import SMCTableActions from '../../../components/core/SMCTableActions/SMCTableActions';
import {ImageFilterSchema} from '../../../api/DBSchema/Image';

function ImageResults({
    customImagePermissions
}) {

    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);
    
    const {
        tableContent,
        isFetching,
        isPageLoaded,
        filterObject,
        setFilterObject,
        freeTextSearch,
        fetchNextPage,
        isLastPage,
        columns,
        sortBasis,
        sortDirection,
        setSort,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        rowIdSelector,
        selectedObjects,
        setSelectedObjects,
        columnsWidths,
        setColumnsWidths,
        newObjectCallback,
        reloadButtonOnClick,
        deleteButtonOnClick
    } = useImageResults();

    const canDelete = customImagePermissions ? customImagePermissions.delete : false;
    const canCreate = customImagePermissions ? customImagePermissions.create : false;

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.imageResults}>
            <div className="DrawResultsDiv">
                <SMCTableActions
                        openNewObjectWindow={openNewObjectWindow}
                        reloadButtonOnClick={reloadButtonOnClick}
                        deleteButtonOnClick={deleteButtonOnClick}
                        toggleFilterPane={toggleFilterPane}
                        canCreate={canCreate}
                        canDelete={canDelete}
                        isFetching={isFetching} 
                        tableContent={tableContent}
                        isFilterPaneOpen={isFilterPaneOpen}
                        selectedObjects={selectedObjects}
                        initialSearch={filterObject}
                        onSearchChange={setFilterObject}
                        searchAttribute={ImageFilterSchema.freeTextSearch}
                /> 
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    rowIdSelector={rowIdSelector}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    isFilterOpen={isFilterPaneOpen}
                    filterElem={
                        <ImageFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    showEditIcon={false}
                />
                {/* Floating windows */}
                <ImageWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    customImagePermissions: customImagePermissionsSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(ImageResults);